import { route } from '@/utils/build'
const component = path => resolve => require(['@/pages/payment/views/' + path], resolve)

/**
 * 我的订单
 */
export default [
  // 我的订单
  route('/orderList', 'orderList', component('order/index'))
]
